import { Runner, Time, RunnerStatus } from './types';

export function CombinedListSort(allClassesSelected: boolean, runner: Runner, time: Time): number {
    if (allClassesSelected) {
        let lastEventTime = null;
        for (const key in runner.times) {
            time = runner.times[key];
            if (time === null || time.passing_time === null) {
                continue;
            }

            const timeAsUnixTime = Date.parse(time.passing_time);
            if (isNaN(timeAsUnixTime)) {
                continue;
            }

            if (lastEventTime == null || lastEventTime < timeAsUnixTime) {
                lastEventTime = timeAsUnixTime;
            }
        }

        if (lastEventTime === null) {
            return Number.MIN_SAFE_INTEGER;
        }
        return lastEventTime;
    }

    if (time === null || time.place === null) {
        // Note that time will be non-null even for intermediate points
        // where the runner has not passed yet, due to "running time".
        if (runner.status == RunnerStatus.REGISTERED) {
            // The runner has not started yet.
            return Number.MAX_SAFE_INTEGER - 6;
        } else if (runner.status == RunnerStatus.OK) {
            return Number.MAX_SAFE_INTEGER - 7;
        }

        // The runner is probably DNS/DNF/etc.
        return GetSortNumberForPlace(runner.status, null, runner.not_competing);
    }

    return GetSortNumberForPlace(runner.status, time.place, runner.not_competing);
}

export function GetSortNumberForPlace(status: RunnerStatus, place: number, notCompeting: boolean): number {
    if (notCompeting && status == RunnerStatus.REGISTERED)
    {
        return Number.MAX_SAFE_INTEGER - 5;
    }

    switch (status) {
        case RunnerStatus.NC:
            return Number.MAX_SAFE_INTEGER - 5;
        case RunnerStatus.DSQ:
            return Number.MAX_SAFE_INTEGER - 4;
        case RunnerStatus.DNF:
            return Number.MAX_SAFE_INTEGER - 3;
        case RunnerStatus.DNS:
            return Number.MAX_SAFE_INTEGER - 2;
        default:
            return place;
    }
}
